import { IEnvVariables } from "@dcl-ue/shared-components/src/types/AppEnvVariables.types";
import { IRecaptchaEnvVars } from "@dcl-ue/shared-components/src/types/RecaptchaEnvVar.types";
import { defaultEnvVars } from "@dcl-ue/shared-components/src/Constants/constants";
import { CURRENCY } from "@ue/environment/constants";

export interface ITransactEnvVariables extends IEnvVariables {
  enableHideProvinceField: string;
  enableHideOrganizationType: string;
  disableLoginPopupModal: string;
  enableLoginModalV2: string;
  isPromoCodeEnabled: string;
  enablePaymentMethodData: string;
  updateLineItemsForCartAction: string;
  enablePhysicalSameAsBillingAddress: string;
  enablePassShippingDetailsEmpty: string;
  annualSubscriptionPurchasingOption: string;
  enableBankAccountPayment: string;
  isWestAccountPaymentEnabled: string;
  enablePassIdpServiceCall: string;
  enableCountryCodePhoneFormat: string;
  enableCheckForMultipleAccounts: string;
  enableOmitCurrencySymbol: string;
  isMessageEnabledPaymentAuthorization: string;
  isBackToPreviousPageEnabled: string;
  DCPCommonLeadService: string;
  dcpUnifiedManipulationAPI: string;
  ciamClientId: string;
  tokenURL: string;
  authorizeURL: string;
  refreshTokenURL: string;
  practicalLawLeadCaptureUrl: string;
  defaultPlanDuration: string;
  site: string;
  defaultNumberOfAttorneys: string;
  fetchTaxEndpoint: string;
  isDeferredLogin: string;
  disableDeferredLoginPopup: string;
  organizationAppType: string;
  fetchOrganizationTypeEndpoint: string;
  disableRegexPattern: string;
  allowedRegexExpression: string;
  boomiPaymetricDecryptEndpoint: string;
  orgTypeDetailsEndpoint: string;
  highqSuccessPage: string;
  configurationName: string;
  applicationId: string;
  companyId: string;
  currency: string;
  currencySymbol: CURRENCY;
  languageCode: string;
  clearCartIdDuration: string;
  emptyCartRedirectionPath: string;
  simulateOrderExtensibleAttributes: string;
  datadogClientToken: string;
  datadogSite: string;
  datadogApplicationId: string;
  datadogService: string;
  datadogEnv: string;
  encryptUserDataEndpoint: string;
  productPricingServiceEndpoint: string;
  pricingDetailsEndpoint: string;
  dcpShareCartEndPoint: string;
  productPricingServiceAppId: string;
  productPricingServiceBrand: string;
  createProposalEndpointV2: string;
  cartManipulationEndpointV2: string;
  cartLineItemDetailsV2: string;
  applyPromotionServiceV2: string;
  useV2TurboPricing: "yes" | "no";
  fingerPrintScriptSource: string;
  orgId: string;
  merchantId: string;
  storeId: string;
  inventoryAPITriggerTime: string;
  apigeeInventoryAPIEndPoint: string;
  apigeeProductRecommendationAPIEndPoint: string;
  apigeeProductRecommendationAPIEndPointV3: string;
  apigeeProductCollateralDetailsEndPoint: string;
  enCAProductPageURL: string;
  frCAProductPageURL: string;
  isOnePassEnabled: string;
  enableCartManipulationReprice: string;
  dcpCountryListEndpoint: string;
  originSite: string;
  smartSaverPurchaseOption?: string;
  oneTimeUpdatePurchaseOption?: string;
  orderActionSiteId?: string;
  apigeeSupplementDetailsEndPoint: string;
  apigeeDecryptTokenEndpoint: string;
  enableTwoFactorAuth?: string;
  createOrderServiceEndpoint: string;
  siteID: string;
  itemBrand: string;
  apigeeOneTrustAPIEndPoint: string;
  marketingConsentPurposeId: string;
  isBuyXgetYEnabled: string;
  isOrderSummaryAddonsEnabled: string;
  autoPayConsentPurposeId: string;
  enableZipAutoComplete: string;
  enableMissingSegmentModal: string;
  orgSegmentLookupEndpoint: string;
  addressInfoApiEndpoint: string;
  isCartExpired: string;
  isBillPlanTypeEnabled: string;
  updateLeadServiceRequestPayload: string;
  enableOrganizationTypeFilter: string;
  enableManualEntryForShipping: string;
  enableCheckForOneAccount: string;
  enablePromoCodeAutoApply: string;
  enablePaymentMethodFeature: string;
  enableShowExistingUserAlert: string;
  enablePhoneNumberWithoutCountryCode: string;
  enablePrePopulateShippingAddress: string;
  enableCartRetention: string;
  enableProductsAnalytics: string;
  enableZipCodeFormatting: string;
  enablePriceMonthLabel: string;
  enableShippingLabel: string;
  enableShippingInfoOnOrderSummaryCart: string;
  enabledZipCodeRegex: string;
  enableStoreDeferredLoginDataInLocalStorage: string;
  enableLeadResponseStore: string;
  enableExtraPayloadForSimulate: string;
  enableOrderMaterialDescription: string;
  enableIncludeFinalRequestJson: string;
  isOrgTypeModalEnabled: string;
  enableCheckoutAllFieldsValidation: string;
  enableUpdatingReduxCountryField: string;
  enableCalculateUnitPricePerQuantity: string;
  enableCalculateOrderTotalWithTax: string;
  enableBillingAddressSearch: string;
  isLegalProduct: string;
  enableReviewRequiredForPaymentPostalCode: string;
  enableCallSimulateOrder: string;
  enablePaymentPostalCodeInputField: string;
  updateOrderDetailsInLeadCreateAPI: string;
  disableBlockListDueToOneAccount: string;
  callSimulateOrderForAutomateAddress: string;
  updateLeadDescriptionPayload: string;
  isModifyPayloadSimulateOrderEnabled: string;
  isSimulateOrderForManualEntryEnabled: string;
  isBankAccountPaymentEnabled: string;
  shareCartSiteId: string;
  enableProductUnavailableAnalytics: string;
  isCAOnline: string;
  shareCartByEmailEndpoint: string;
  shareCartOnlineEndpoint: string;
  getPromotionDetailsEndpoint: string;
  enableCheckoutShippingInformation: string;
  enableMultipleAccountsCheckForExistingUsers: string;
  enablePercentageDiscountDisplay: string;
  liveChatV2OrgId?: string;
  liveChatV2DeploymentName?: string;
  liveChatV2BaseURL?: string;
  liveChatV2SCRT2URL?: string;
  liveChatV2Src?: string;
  liveChatV2UniqueIdentifier?: string;
  enableAutoPaymentAuthorization?: string;
  enablePrePopulateAddressSignedInUsers: string;
  enableRefreshToken?: string;
  enablePromotionCheckForProducts: string;
  shouldDisplayBestPriceBanner?: string;
  isBusinessSectorApplicable?: string;
  isBankAccountDelayMessageEnabled?: string;
  enableStripePayment: string;
  boomiOnboardCustomerEndpoint: string;
  stripePublishableKey: string;
  coveoRelayTrackingId?: string;
  coveoSearchEndpoint?: string;
  coveoTokenRenewalEndpoint?: string;
  coveoRelayApiUrl?: string;
  enableLearnMoreModalForAddons?: string;
  enableWestAccountAndStripeDualPaymentOptions?: string;
  enableGstInclusivePricing?: string;
  enableGstDesignUpdates?: string;
  enableTaxCalculationWithoutMonthlyProducts?: string;
}

export const defaultEnvVariables = {
  ...defaultEnvVars,
  enableHideProvinceField: "",
  enableHideOrganizationType: "",
  disableLoginPopupModal: "",
  enableLoginModalV2: "",
  updateLeadDescriptionPayload: "",
  DCPCommonLeadService: "",
  ciamClientId: "",
  tokenURL: "",
  authorizeURL: "",
  refreshTokenURL: "",
  reCaptchaSiteKey: "",
  practicalLawLeadCaptureUrl: "",
  defaultPlanDuration: "1",
  defaultNumberOfAttorneys: "1",
  fetchTaxEndpoint: "",
  isDeferredLogin: "",
  disableDeferredLoginPopup: "",
  organizationAppType: "",
  fetchOrganizationTypeEndpoint: "",
  disableRegexPattern: "",
  allowedRegexExpression: "",
  boomiPaymetricDecryptEndpoint: "",
  orgTypeDetailsEndpoint: "",
  highqSuccessPage: "",
  configurationName: "",
  applicationId: "",
  companyId: "",
  currency: "",
  languageCode: "",
  clearCartIdDuration: "",
  emptyCartRedirectionPath: "",
  simulateOrderExtensibleAttributes: "",
  datadogClientToken: "",
  datadogSite: "",
  datadogApplicationId: "",
  datadogService: "",
  datadogEnv: "",
  encryptUserDataEndpoint: "",
  fingerPrintScriptSource: "",
  orgId: "",
  useV2TurboPricing: "no",
  merchantId: "",
  storeId: "",
  inventoryAPITriggerTime: "20:00:00",
  apigeeInventoryAPIEndPoint: "",
  apigeeProductRecommendationAPIEndPoint: "",
  apigeeProductRecommendationAPIEndPointV3: "",
  enCAProductPageURL: "",
  frCAProductPageURL: "",
  isOnePassEnabled: "true",
  enableCartManipulationReprice: "true",
  dcpCountryListEndpoint: "",
  apigeeSupplementDetailsEndPoint: "",
  apigeeDecryptTokenEndpoint: "",
  siteID: "",
  itemBrand: "",
  apigeeOneTrustAPIEndPoint: "",
  marketingConsentPurposeId: "",
  autoPayConsentPurposeId: "",
  enableZipAutoComplete: "",
  enableMissingSegmentModal: "",
  orgSegmentLookupEndpoint: "",
  addressInfoApiEndpoint: "",
  isCartExpired: "",
  isBuyXgetYEnabled: "",
  isOrderSummaryAddonsEnabled: "",
  enableManualEntryForShipping: "",
  enableCheckForOneAccount: "",
  enablePaymentMethodFeature: "",
  enableCartRetention: "",
  enableStoreDeferredLoginDataInLocalStorage: "",
  enableLeadResponseStore: "",
  enableIncludeFinalRequestJson: "",
  isOrgTypeModalEnabled: "",
  enableCheckoutAllFieldsValidation: "",
  enableCalculateUnitPricePerQuantity: "",
  enableCalculateOrderTotalWithTax: "",
  enableBillingAddressSearch: "",
  isLegalProduct: "",
  enableReviewRequiredForPaymentPostalCode: "",
  enableCallSimulateOrder: "",
  enableProductUnavailableAnalytics: "",
  enablePaymentPostalCodeInputField: "",
  disableBlockListDueToOneAccount: "",
  callSimulateOrderForAutomateAddress: "",
  isModifyPayloadSimulateOrderEnabled: "",
  isSimulateOrderForManualEntryEnabled: "",
  isBankAccountPaymentEnabled: "false",
  shareCartSiteId: "",
  isCAOnline: "",
  shareCartByEmailEndpoint: "",
  shareCartOnlineEndpoint: "",
  getPromotionDetailsEndpoint: "",
  productPricingServiceBrand: "",
  enableCheckoutShippingInformation: "",
  enableMultipleAccountsCheckForExistingUsers: "",
  enablePercentageDiscountDisplay: "",
  liveChatV2OrgId: "",
  liveChatV2DeploymentName: "",
  liveChatV2BaseURL: "",
  liveChatV2SCRT2URL: "",
  liveChatV2Src: "",
  liveChatV2UniqueIdentifier: "",
  enableAutoPaymentAuthorization: "",
  isWestAccountPaymentEnabled: "",
  enablePrePopulateAddressSignedInUsers: "",
  enableRefreshToken: "",
  enablePromotionCheckForProducts: "",
  shouldDisplayBestPriceBanner: "false",
  isBusinessSectorApplicable: "true",
  isBankAccountDelayMessageEnabled: "false",
  enableStripePayment: "",
  boomiOnboardCustomerEndpoint: "",
  stripePublishableKey: "",
  coveoRelayTrackingId: "",
  coveoSearchEndpoint: "",
  coveoTokenRenewalEndpoint: "",
  coveoRelayApiUrl: "",
  enableLearnMoreModalForAddons: "",
  annualSubscriptionPurchasingOption: "",
  enableWestAccountAndStripeDualPaymentOptions: "",
  enableOrderMaterialDescription: "",
  enableShippingInfoOnOrderSummaryCart: "",
  pricingDetailsEndpoint: "",
  enableGstInclusivePricing: "",
  enableGstDesignUpdates: "",
  enableTaxCalculationWithoutMonthlyProducts: "",
} as ITransactEnvVariables;

let envVariables: ITransactEnvVariables;

export const initEnvVariables = () => {
  const envConfigFromAEM = document.getElementById("env-config") as HTMLElement;
  const envConfigParsed = JSON.parse(
    envConfigFromAEM?.innerHTML ?? JSON.stringify(defaultEnvVariables)
  );
  envVariables = Object.assign({}, defaultEnvVariables, envConfigParsed);
};

export const getEnvVariables = () => {
  if (!envVariables) {
    initEnvVariables();
  }

  return envVariables;
};

export const getEnvVar = (key: keyof ITransactEnvVariables): string => {
  const envVars = getEnvVariables();
  return envVars[key] || "";
};

export const getRecaptchaEnvVar = (): IRecaptchaEnvVars => {
  const {
    apigeeClientId,
    reCaptchaVerifyUrl,
    reCaptchaSiteKey,
  } = getEnvVariables();
  return {
    apiKey: apigeeClientId,
    reCaptchaVerifyUrl,
    reCaptchaSiteKey,
  };
};
